export const CSS_CLASSES = {
  IMAGE_FIT_CONTAIN: "image-fit-contain",
  IMAGE_FIT_COVER: "image-fit-cover",
  IMAGE_FIT_FILL: "image-fit-fill",
  IMAGE_FIT_NONE: "image-fit-none",
  IMAGE_FIT_SCALE_DOWN: "image-fit-scale-down",

  IMAGE_POSITION_CENTER: "image-position-center",
  IMAGE_POSITION_TOP: "image-position-top",
  IMAGE_POSITION_RIGHT_TOP: "image-position-right-top",
  IMAGE_POSITION_RIGHT: "image-position-right",
  IMAGE_POSITION_RIGHT_BOTTOM: "image-position-right-bottom",
  IMAGE_POSITION_BOTTOM: "image-position-bottom",
  IMAGE_POSITION_LEFT_BOTTOM: "image-position-left-bottom",
  IMAGE_POSITION_LEFT: "image-position-left",
  IMAGE_POSITION_LEFT_TOP: "image-position-left-top",
};
